import { incidentReportsConstants } from 'locale/incidentReports'

export type ActionTemplate = {
  id: string
  titleKey: string
  detailsKey: string
}

/**
 * The designed templates, in the designed order. Held in the client: there is
 * no per-provider list yet. Copy may interpolate `carePlan` (the home's name
 * for a care plan) and `name` (the service user's).
 */
export const ACTION_TEMPLATES: ReadonlyArray<ActionTemplate> = [
  {
    id: 'carePlan',
    titleKey: incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_CARE_PLAN,
    detailsKey:
      incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_CARE_PLAN_DETAILS
  },
  {
    id: 'riskAssessments',
    titleKey:
      incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_RISK_ASSESSMENTS,
    detailsKey:
      incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_RISK_ASSESSMENTS_DETAILS
  },
  {
    id: 'localAuthority',
    titleKey: incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_LOCAL_AUTHORITY,
    detailsKey:
      incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_LOCAL_AUTHORITY_DETAILS
  },
  {
    id: 'safeguardingReferral',
    titleKey:
      incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_SAFEGUARDING_REFERRAL,
    detailsKey:
      incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_SAFEGUARDING_REFERRAL_DETAILS
  },
  {
    id: 'staffDebrief',
    titleKey: incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_STAFF_DEBRIEF,
    detailsKey:
      incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_STAFF_DEBRIEF_DETAILS
  },
  {
    id: 'nextOfKin',
    titleKey: incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_NEXT_OF_KIN,
    detailsKey:
      incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_NEXT_OF_KIN_DETAILS
  },
  {
    id: 'staffTraining',
    titleKey: incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_STAFF_TRAINING,
    detailsKey:
      incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_STAFF_TRAINING_DETAILS
  },
  {
    id: 'policyChanges',
    titleKey: incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_POLICY_CHANGES,
    detailsKey:
      incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_POLICY_CHANGES_DETAILS
  },
  {
    id: 'equipmentReplacement',
    titleKey:
      incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_EQUIPMENT_REPLACEMENT,
    detailsKey:
      incidentReportsConstants.CASE_V2_ACTIONS_TEMPLATE_EQUIPMENT_REPLACEMENT_DETAILS
  }
]
